@if (job()) {
  <ct-lib-dropdown
    class="actions-dropdown"
    [closeOnClick]="true"
    [dropdown]="actionDropdown"
    [autowidth]="true"
    [alignment]="alignment()"
    (onOpen)="refreshJobOnDropdownOpen()"
    #actionDropdownEl
  >
    <ng-content>
      <fa-icon
        [icon]="fontawesomeService.light.ellipsisV"
        size="md"
        class="more-actions-dropdown"
        [tooltip]="
          'company-tool.views.jobs.list.table.actions.more' | transloco
        "
        position="right"
      ></fa-icon>
    </ng-content>
  </ct-lib-dropdown>
  <ng-template #actionDropdown>
    <ul>
      <!-- Edit Action -->
      <li
        [routerLink]="disabled() ? undefined : ['/jobs/' + jobId() + '/edit']"
      >
        <fa-icon
          class="text-secondary"
          [icon]="fontawesomeService.light.pen"
          size="sm"
        ></fa-icon>
        <p>
          {{ 'company-tool.views.jobs.list.table.actions.edit' | transloco }}
        </p>
      </li>

      <!-- Duplicate Action -->
      <li
        [class.disabled]="actionDisabled()"
        (click)="duplicateJob(actionDropdownEl); $event.stopPropagation()"
      >
        @if (currentAction() === 'duplicate') {
          <ct-lib-spinner [color]="'#0a242e'"></ct-lib-spinner>
        } @else {
          <fa-icon [icon]="fontawesomeService.light.copy" size="sm"></fa-icon>
        }
        <p>
          {{
            'company-tool.views.jobs.list.table.actions.duplicate' | transloco
          }}
        </p>
      </li>

      <li class="divider"></li>

      <!-- Change Slot Type Action -->
      @if (job()?.state === JobState.OPEN) {
        <li (click)="changeSlotTypeModal.modal.open()">
          @if (disabled() && currentAction() === 'change-slot-type') {
            <ct-lib-spinner [color]="'#0a242e'"></ct-lib-spinner>
          } @else {
            <fa-icon
              [icon]="fontawesomeService.light.megaphone"
              size="sm"
            ></fa-icon>
          }
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.change-slot-type'
                | transloco
            }}
          </p>
        </li>
      }

      <!-- Book distribution / campaign -->
      @if (
        job()?.state === JobState.OPEN &&
        job()?.slotType !== SlotType.NOT_LISTED
      ) {
        <li (click)="requestBookDistribution()">
          <fa-icon
            [icon]="fontawesomeService.light.chartNetwork"
            size="sm"
          ></fa-icon>
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.book-distribution'
                | transloco
            }}
          </p>
        </li>
      }

      <!-- Close/Open Job Action -->
      @if (job()?.state === JobState.OPEN) {
        <li (click)="closeJobConfirmModal.modal.open()">
          @if (disabled() && currentAction() === 'close') {
            <ct-lib-spinner [color]="'red'"></ct-lib-spinner>
          } @else {
            <fa-icon
              [icon]="fontawesomeService.light.lockClosed"
              size="sm"
            ></fa-icon>
          }
          <p>
            {{ 'company-tool.views.jobs.list.table.actions.close' | transloco }}
          </p>
        </li>
      } @else if (job()?.state === JobState.CLOSED) {
        <li
          (click)="openJobConfirmModal.modal.open()"
          blockInDisabledMode
          tooltip
        >
          @if (disabled() && currentAction() === 'open') {
            <ct-lib-spinner [color]="'#0a242e'"></ct-lib-spinner>
          } @else {
            <fa-icon
              [icon]="fontawesomeService.light.lockOpen"
              size="sm"
            ></fa-icon>
          }
          <p>
            {{ 'company-tool.views.jobs.list.table.actions.open' | transloco }}
          </p>
        </li>
      }

      @if (!isDraft()) {
        <!-- Archive Job Action -->
        <li
          (click)="disabled() ? undefined : archiveJobConfirmModal.modal.open()"
        >
          <fa-icon [icon]="fontawesomeService.light.archive" size="sm"></fa-icon>
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.archive' | transloco
            }}
          </p>
        </li>
        <!-- Show Action -->
        <li>
          <a [href]="disabled() ? undefined : jobLink()" target="_blank">
            <fa-icon
              [icon]="fontawesomeService.light.externalLink"
              size="sm"
            ></fa-icon>
            <p>
              {{
                'company-tool.views.jobs.list.table.actions.show' | transloco
              }}
            </p>
          </a>
        </li>
      }

      @if (!isDraft()) {
        <!-- Copy Application Import Mail Action -->
        <li (click)="copyApplicationImportMail()">
          <fa-icon [icon]="fontawesomeService.light.envelope" size="sm"></fa-icon>
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.copy-email' | transloco
            }}
          </p>
        </li>

        <li class="divider"></li>
      }

      <!-- Delete Job Action -->
      @if (isJobDeletable()) {
        <li (click)="deleteJobConfirmModal.modal.open()">
          @if (disabled() && currentAction() === 'delete') {
            <ct-lib-spinner [color]="'red'"></ct-lib-spinner>
          } @else {
            <fa-icon
              class="text-red"
              [icon]="fontawesomeService.light.trash"
              size="sm"
            ></fa-icon>
          }
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.delete' | transloco
            }}
          </p>
        </li>
      } @else {
        @if (job()?.demo && jobsService.disabledModeActive()) {
          <li
            class="disabled"
            [disabled]="true"
            [tooltip]="
              'company-tool.views.jobs.list.cant-delete-demo' | transloco
            "
            position="left"
          >
            <fa-icon
              class="text-red"
              [icon]="fontawesomeService.light.trash"
              size="sm"
            ></fa-icon>
            <p>
              {{
                'company-tool.views.jobs.list.table.actions.delete' | transloco
              }}
            </p>
          </li>
        } @else {
          <li (click)="cantDeleteJobModal.modal.open()">
            <fa-icon
              class="text-red"
              [icon]="fontawesomeService.light.trash"
              size="sm"
            ></fa-icon>
            <p>
              {{
                'company-tool.views.jobs.list.table.actions.delete' | transloco
              }}
            </p>
          </li>
        }
      }

      @if (!isProduction && !isDraft()) {
        <li (click)="regenerateJobSummaryAndScreeningsModal.modal.open()">
          <fa-icon [icon]="fontawesomeService.light.redo" size="sm"></fa-icon>
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.retrigger-summary-and-screenings'
                | transloco
            }}
          </p>
        </li>
        <li (click)="triggerRecommendationsModal.modal.open()">
          <fa-icon
            [icon]="fontawesomeService.light.sparkles"
            size="sm"
          ></fa-icon>
          <p>
            {{
              'company-tool.views.jobs.list.table.actions.trigger-recommendations'
                | transloco
            }}
          </p>
        </li>
      }
    </ul>
  </ng-template>

  <ct-lib-confirm-modal
    #changeSlotTypeModal
    (onConfirm)="
      handleAction(
        jobsService.changeSlotType(job(), changeSlotModalSelection()),
        'change-slot-type'
      )
    "
    (onOpen)="
      changeSlotModalSelection.set(job()?.slotType ?? preselectSlotType())
    "
    (click)="$event.stopPropagation()"
    [label]="
      'company-tool.views.jobs.list.slot-type-change-modal.label' | transloco
    "
    [disableConfirmButton]="changeSlotModalSelection() === null"
    [size]="'lg'"
  >
    <p>
      {{
        'company-tool.views.jobs.list.slot-type-change-modal.info' | transloco
      }}
    </p>
    <app-slot-selector
      class="mt-3"
      [selectedSlotType]="changeSlotModalSelection()"
      (selectedSlotTypeChange)="changeSlotModalSelection.set($event)"
      [initialSlotType]="job()?.slotType"
      [isOpen]="job()?.state === JobState.OPEN"
    ></app-slot-selector>
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #archiveJobConfirmModal
    (onConfirm)="handleAction(jobsService.archive([job()]), 'archive')"
    (click)="$event.stopPropagation()"
  >
    {{
      'company-tool.views.jobs.list.table.actions.archive-modal.text'
        | transloco
    }}
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #deleteJobConfirmModal
    (onConfirm)="handleAction(jobsService.delete([job()]), 'delete')"
    (click)="$event.stopPropagation()"
  >
    {{
      'company-tool.views.jobs.list.table.actions.delete-modal.text' | transloco
    }}
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #cantDeleteJobModal
    [hideCancelButton]="true"
    [confirmLabel]="
      'company-tool.views.jobs.list.table.actions.cant-delete-modal.confirm'
        | transloco
    "
    [label]="
      'company-tool.views.jobs.list.table.actions.cant-delete-modal.title'
        | transloco
    "
    (click)="$event.stopPropagation()"
  >
    <p
      [innerHTML]="
        'company-tool.views.jobs.list.table.actions.cant-delete-modal.text'
          | transloco
      "
    ></p>
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #closeJobConfirmModal
    (onConfirm)="handleAction(jobsService.close([job()]), 'close')"
    (click)="$event.stopPropagation()"
  >
    {{
      'company-tool.views.jobs.list.table.actions.close-modal.text' | transloco
    }}
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #openJobConfirmModal
    (onOpen)="openJobSlotSelection.set(job()?.slotType ?? preselectSlotType())"
    (onConfirm)="
      handleAction(
        jobsService.open(
          [job()],
          job()?.demo ? job()?.slotType : openJobSlotSelection()
        ),
        'open'
      )
    "
    (click)="$event.stopPropagation()"
    [label]="
      'company-tool.views.jobs.list.confirm-open-modal.label' +
        (job()?.demo ? '-demo' : '') | transloco
    "
    [disableConfirmButton]="openJobSlotSelection() === null"
    [size]="'lg'"
  >
    @if (jobsService.disabledModeActive()) {
      <ct-lib-info-banner type="warning">
        {{
          'company-tool.views.jobs.posting.saver.publish-modal.sandbox-header'
            | transloco
        }}
      </ct-lib-info-banner>
    }
    <p>
      {{ 'company-tool.views.jobs.list.confirm-open-modal.info' | transloco }}
    </p>
    <app-slot-selector
      class="mt-3"
      [selectedSlotType]="openJobSlotSelection()"
      (selectedSlotTypeChange)="openJobSlotSelection.set($event)"
      [initialSlotType]="job()?.slotType"
      [isOpen]="true"
    ></app-slot-selector>
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #regenerateJobSummaryAndScreeningsModal
    (onConfirm)="regenerateJobSummaryAndScreenings()"
  >
    {{
      'company-tool.views.jobs.list.table.actions.retrigger-summary-and-screenings-modal.text'
        | transloco
    }}
  </ct-lib-confirm-modal>

  <ct-lib-confirm-modal
    #triggerRecommendationsModal
    (onConfirm)="triggerRecommendations()"
  >
    {{
      'company-tool.views.jobs.list.table.actions.trigger-recommendations-modal.text'
        | transloco
    }}
  </ct-lib-confirm-modal>
}
